import { LoaderFunctionArgs, redirect } from "react-router";
import * as Config from "config";
export default async function rootLoader(args: LoaderFunctionArgs) {
  if (args.request.url === `${Config.siteBaseUrl}/`) return redirect('/dashboard');
  return null;
}
